import React from 'react';
import classNames from 'classnames';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import fr from 'facet-rest';
import metaOverrideSet from 'Views/Page/Content/Templates/WizardTemplates/DoLQuestionnaireTemplate/dolMetaOverride';
import Content from './dolQuestionnaireContent';

const useStyles = buildUseStyles('DoLQuestionnaireTemplate', (() => ({
  root: {},
})));

const DoLQuestionnaireTemplate = ({
  className,
  resource,
}) => {
  const classes = useStyles();
  return (
    <WizardStepWrapperTemplate
      className={classNames(className, classes.root)}
      metaOverrideSet={metaOverrideSet}
      resource={resource}
      layout={Content}
    />
  );
};

DoLQuestionnaireTemplate.defaultProps = {
  className: '',
};

DoLQuestionnaireTemplate.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default DoLQuestionnaireTemplate;
